import sum from 'lodash/sum'
import sumBy from 'lodash/sumBy'
import round from 'lodash/round'

const getOnlyNumber = value => `${value}`.replace(/[^\d.-]/g, '')

export const formatDollarsToCents = value => {
  const onlyNumber = getOnlyNumber(value)
  return onlyNumber ? round(onlyNumber * 100) : 0
}

export const formatCentsToDollars = value => {
  const onlyNumber = getOnlyNumber(value)
  return onlyNumber ? onlyNumber / 100 : 0
}

export const formatDollarsToDecimalCents = value => {
  const onlyNumber = getOnlyNumber(value)
  return onlyNumber ? round(onlyNumber * 100, 2) : 0
}

export const formatDecimalCentsToDollars = value => {
  const onlyNumber = getOnlyNumber(value)
  return onlyNumber ? round(onlyNumber / 100, 4) : 0
}

export const calculateSum = (arr, key) => {
  if (!Array.isArray(arr) || !arr.length) {
    return 0
  }

  return key ? sumBy(arr, key) : sum(arr)
}

export const shortenMoneyValue = ({ value, minimumFractionDigits = 2, maximumFractionDigits = 2, prefix = '' }) => {
  if (!value) {
    const zero = 0
    return `${prefix}${zero.toLocaleString(undefined, { minimumFractionDigits, maximumFractionDigits })}`
  }

  const suffixes = ['', 'K', 'M', 'B', 'T', 'P', 'E']
  const isNegative = value < 0
  const absoluteValue = Math.abs(value)

  if (absoluteValue < 1) {
    return `${isNegative ? '-' : ''}${prefix}${absoluteValue.toLocaleString(undefined, { minimumFractionDigits, maximumFractionDigits })}`
  }

  const tier = Math.floor(Math.log10(absoluteValue) / 3)

  if (tier === 0) {
    return `${isNegative ? '-' : ''}${prefix}${absoluteValue.toLocaleString(undefined, { minimumFractionDigits, maximumFractionDigits })}`
  }

  const suffix = suffixes[tier]
  const scale = 10 ** (tier * 3)
  const scaledValue = absoluteValue / scale
  return `${isNegative ? '-' : ''}${prefix}${scaledValue.toLocaleString(undefined, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 1,
  })}${suffix}`
}

export const roundToScale = (value, scale = 2) => round(value, scale)

export const formatCurrency = (amount, rest) => {
  try {
    return Number(getOnlyNumber(amount)).toLocaleString('en-US', { style: 'currency', currency: 'USD', ...rest })
  } catch (error) {
    return '$0.00'
  }
}

export const formatCentsToCurrency = (cents, rest) => {
  const dollars = formatCentsToDollars(cents)
  return formatCurrency(dollars, rest)
}
